/**
 * AI Chat discovery experiment (nav vs floating rail).
 */
export const AI_APP_PATH = '/app/ai'

export const AI_CHAT_DISCOVERY_EXPERIMENT_KEY = 'ai_assistant_entry_point_experience'

export const AI_CHAT_DISCOVERY_VARIANT = {
  CONTROL: 'control',
  LEFT_LOGO: 'left_logo_test_a',
  LEFT_BUTTON: 'left_button_test_b',
  LOGO_ONLY: 'logo_test_c',
  BUTTON_ONLY: 'button_test_d',
}

/** Two FAB shapes only: round icon for later vs text label. */
export const AI_CHAT_DISCOVERY_FAB_APPEARANCE = {
  ICON: 'icon',
  STRING: 'string',
}

const PHASE_1_DISCOVERY_VARIANT_SET = new Set([
  AI_CHAT_DISCOVERY_VARIANT.CONTROL,
  AI_CHAT_DISCOVERY_VARIANT.BUTTON_ONLY,
])

/**
 * Maps experiment variant to effective variant for the current phase.
 * @param {string | null | undefined} variant — raw `useVariant` value
 * @returns {typeof AI_CHAT_DISCOVERY_VARIANT.CONTROL | typeof AI_CHAT_DISCOVERY_VARIANT.BUTTON_ONLY}
 */
export const getAiChatDiscoveryEffectiveVariant = (variant) => {
  if (!variant) return AI_CHAT_DISCOVERY_VARIANT.CONTROL
  if (PHASE_1_DISCOVERY_VARIANT_SET.has(variant)) return variant
  return AI_CHAT_DISCOVERY_VARIANT.CONTROL
}
